import React from 'react';
import { QuestionGroupViewPropTypes } from '../../utils';
import { NeuroChart } from '../../../neuro-ui/lib/NeuroChart';
import { NeuroMessage } from '../index.mjs';
import { useAnswers } from '../../hooks/useAnswers';
import { DEFAULT_CHART_COLORS } from '../../utils/constants.mjs';
import classNames from 'classnames';

const Chart = ({ questionGroup, renderQuestion, className }) => {
  const { chartConfig } = questionGroup.attributes;
  const questions = questionGroup.questions || [];
  const { answers } = useAnswers();

  // Build chart data from question answers with proper format
  const chartData = questions.map((question, index) => ({
    id: question.appkey,
    label: <NeuroMessage id={question.appkey} />,
    value: answers[question.appkey]?.value || 0,
    color: (chartConfig?.colors && chartConfig.colors[index]) || DEFAULT_CHART_COLORS[index % DEFAULT_CHART_COLORS.length]
  }));

  // Calculate total for center display
  const total = chartData.reduce((sum, item) => sum + item.value, 0);

  // Add metrics for center display if showTotal is enabled
  const metrics = chartConfig?.showTotal ? {
    top: `${chartConfig.totalPrefix || '$'}${total.toLocaleString()}`
  } : undefined;

  return (
    <div className={classNames('chartQuestionGroup', className)}>
      <div className="chartQuestionGroup__content">
        <div className="chartQuestionGroup__questions">
          {questions.map((question) => renderQuestion(question))}
        </div>
        
        <div className="chartQuestionGroup__chart">
          {chartConfig?.headerMessage && (
            <div className="chartQuestionGroup__header">
              <NeuroMessage id={`${chartConfig.chartKey}.header`} shouldHideIfNotFound />
            </div>
          )}
          
          <NeuroChart 
            config={{
              ...chartConfig,
              data: chartData,
              metrics,
              colors: chartData.map(d => d.color),
              isInteractive: chartConfig?.isInteractive || false,
              showLegend: chartConfig?.showLegend !== undefined ? chartConfig.showLegend : true,
              margin: { top: 20, right: 20, bottom: 180, left: 20 },
              legends: [
                {
                  anchor: 'bottom',
                  direction: 'column',
                  justify: false,
                  translateX: 0,
                  translateY: 160,
                  itemsSpacing: 12,
                  itemWidth: 120,
                  itemHeight: 25,
                  itemDirection: 'left-to-right',
                  itemOpacity: 1,
                  symbolSize: 18,
                  symbolShape: 'circle'
                }
              ]
            }}
          />

          {chartConfig?.footerMessage && (
            <div className="chartQuestionGroup__footer">
              <NeuroMessage id={`${chartConfig.chartKey}.footer`} shouldHideIfNotFound />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

Chart.propTypes = QuestionGroupViewPropTypes;

export default Chart;